"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.button = exports.panel = exports.text = exports.secondary = exports.primary = void 0;
var scales_1 = require("./scales");
var constants_1 = require("./constants");
exports.primary = {
    main: scales_1.Aqua[700],
    dark: scales_1.Aqua[800],
    light: scales_1.Teal[200],
    contrastText: constants_1.white,
    disabled: '#C0D8DB',
};
exports.secondary = {
    main: scales_1.DarkGreen[400],
    dark: scales_1.DarkGreen[800],
    light: scales_1.DarkGreen[100],
    contrastText: constants_1.white,
};
exports.text = {
    main: scales_1.NTDarkGrey[700],
    dark: scales_1.NTDarkGrey[800],
    light: scales_1.NTDarkGrey[200],
    positive: scales_1.Green[800],
    negative: scales_1.Red[600],
    disabled: scales_1.NTDarkGrey[200],
    warning: scales_1.Yellow[500],
    error: scales_1.Red[500],
};
exports.panel = {
    main: exports.text.main,
    border: scales_1.LightGreen[700],
    label: exports.text.main,
    required: exports.text.error,
    sectionTitle: exports.text.main,
};
exports.button = {
    secondary: '#252627',
    secondaryBoxShadow: scales_1.NTDarkGrey[500],
};
